"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getSlug = require('speakingurl');

exports.capitalize = function (string) {
  return string.charAt(0).toUpperCase() + string.substr(1);
};

exports.transliterate = function (string) {
  return getSlug(string) || '-';
};

exports.transliteratedAlphabet = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'ye',
  ё: 'yo',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'shch',
  э: 'e',
  ю: 'yu',
  я: 'ya'
};

exports.replaceLinebreaks = function (string) {
  return string.replace(new RegExp('(\\r\\n|\\r|\\n)', 'g'), '<br>');
};

var initialTagsRegex = new RegExp('^(\\s*<[^>]*>\\s*)+', 'i');
var initialLetterRegex = new RegExp('[а-яА-ЯA-Za-z]', 'i');

exports.getInitialLetterIndex = function (text) {
  var letterIndex = 0;
  var tagsMatch = text.match(initialTagsRegex);

  if (tagsMatch) {
    var tags = tagsMatch[0];
    letterIndex += tags.length;
  }

  var initialLetter = text.charAt(letterIndex);

  if (!initialLetterRegex.test(initialLetter)) {
    letterIndex = -1;
  }

  return letterIndex;
};

exports.getOrdinalSuffix = function (number, string, suffix) {
  var index = ((number + 90) % 100 - 10) % 10;
  var targetSuffix;

  if (index > 1 && index <= suffix.length + 1) {
    var _suffix = _slicedToArray(suffix, 3);

    targetSuffix = _suffix[2];
  } else {
    targetSuffix = suffix[index] || suffix[0];
  }

  return string + targetSuffix;
};

var firstBracketsRegex = new RegExp('^[<«]+', 'i');
var lastBracketsRegex = new RegExp('[>»]+$', 'i');

exports.trimBrackets = function (text) {
  return text.replace(firstBracketsRegex, '').replace(lastBracketsRegex, '');
};